export default  { 
    API: "https://api.sgaabj.sogak.com.mx" ,   // http://sogak.dyndns.org:3100
    SOCKET: window.location.hostname == "192.168.0.253" ? "http://192.168.0.253:3000" :  "https://appmroaam.com:16500",  //https://appmroaam.com:16500
}